import { useRef } from "react";

const clamp = (v) => Math.min(Math.max(v, 0), 1);

// Red arrow overlay: drag the body to move it, drag either end dot to aim and resize.
export function ArrowBox({ stageRef, shape, onChange, onCommit, onSelect, active, testId }) {
  const start = useRef(null);
  const down = (mode) => (e) => {
    e.preventDefault(); e.stopPropagation();
    e.currentTarget.setPointerCapture(e.pointerId);
    onSelect();
    start.current = { mode, px: e.clientX, py: e.clientY, s: shape };
  };
  const move = (e) => {
    const st = start.current;
    if (!st) return;
    const r = stageRef.current.getBoundingClientRect(), s = st.s;
    const dx = (e.clientX - st.px) / r.width, dy = (e.clientY - st.py) / r.height;
    if (st.mode === "tail") onChange({ ...s, x: clamp(s.x + dx), y: clamp(s.y + dy) });
    else if (st.mode === "head") onChange({ ...s, x2: clamp(s.x2 + dx), y2: clamp(s.y2 + dy) });
    else {
      const mx = Math.min(Math.max(dx, -Math.min(s.x, s.x2)), 1 - Math.max(s.x, s.x2));
      const my = Math.min(Math.max(dy, -Math.min(s.y, s.y2)), 1 - Math.max(s.y, s.y2));
      onChange({ ...s, x: s.x + mx, y: s.y + my, x2: s.x2 + mx, y2: s.y2 + my });
    }
  };
  const up = () => { if (start.current) { start.current = null; onCommit(); } };
  const h = { onPointerMove: move, onPointerUp: up, onPointerCancel: up };
  const r = stageRef.current?.getBoundingClientRect();
  const W = r?.width || 1, H = r?.height || 1;
  const len = Math.hypot((shape.x2 - shape.x) * W, (shape.y2 - shape.y) * H);
  const ang = Math.atan2((shape.y2 - shape.y) * H, (shape.x2 - shape.x) * W);
  const dot = (mode, x, y) => (
    <span data-testid={`${testId}-${mode}`} onPointerDown={down(mode)} {...h}
      className={`absolute z-30 w-3.5 h-3.5 -ml-[7px] -mt-[7px] rounded-full bg-white border-2 border-zinc-900 cursor-crosshair touch-none ${active ? "" : "opacity-0 hover:opacity-100"}`}
      style={{ left: `${x * 100}%`, top: `${y * 100}%` }} />
  );
  return (
    <>
      <div data-testid={testId} onPointerDown={down("move")} {...h} title="Drag to move arrow"
        className={`absolute z-10 h-8 -mt-4 cursor-move touch-none select-none border-2 border-dashed transition-colors ${active ? "border-yellow-400" : "border-transparent hover:border-white/70"}`}
        style={{ left: `${shape.x * 100}%`, top: `${shape.y * 100}%`, width: len, transform: `rotate(${ang}rad)`, transformOrigin: "0 50%" }} />
      {dot("tail", shape.x, shape.y)}
      {dot("head", shape.x2, shape.y2)}
    </>
  );
}
